import { defaultFill } from '../../../utils/constants';
var muiSearch16 = {
    paths: [
        {
            path: 'M6,0 C9.3137085,0 12,2.6862915 12,6 C12,7.29583043 11.589209,8.49571549 10.8907479,9.47653436 L10.8907479,9.47653436 L13.7071068,12.2928932 C14.0976311,12.6834175 14.0976311,13.3165825 13.7071068,13.7071068 C13.3165825,14.0976311 12.6834175,14.0976311 12.2928932,13.7071068 L12.2928932,13.7071068 L9.47653436,10.8907479 C8.49571549,11.589209 7.29583043,12 6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 Z M6,2 C3.790861,2 2,3.790861 2,6 C2,8.209139 3.790861,10 6,10 C8.209139,10 10,8.209139 10,6 C10,3.790861 8.209139,2 6,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Search',
    width: 14,
    height: 14,
};
var muiSearch24 = {
    paths: [
        {
            path: 'M9.5,0 C14.7467051,0 19,4.25329488 19,9.5 C19,11.7631465 18.2086338,13.8414595 16.8875269,15.4733134 L21.7071068,20.2928932 C22.0976311,20.6834175 22.0976311,21.3165825 21.7071068,21.7071068 C21.3165825,22.0976311 20.6834175,22.0976311 20.2928932,21.7071068 L15.4733134,16.8875269 C13.8414595,18.2086338 11.7631465,19 9.5,19 C4.25329488,19 0,14.7467051 0,9.5 C0,4.25329488 4.25329488,0 9.5,0 Z M9.5,2 C5.35786438,2 2,5.35786438 2,9.5 C2,13.6421356 5.35786438,17 9.5,17 C13.6421356,17 17,13.6421356 17,9.5 C17,5.35786438 13.6421356,2 9.5,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Search',
    width: 22,
    height: 22,
};
var muiSearch = {
    base: muiSearch16,
    smIcon: muiSearch16,
    lgIcon: muiSearch24,
};
export { muiSearch };
//# sourceMappingURL=search.js.map